import { createStore, createHook } from 'react-sweet-state';

type State = {
	// hierarchy level that is used to fetch top level items
	hierarchyLevel?: number;
};

const initialState = { hierarchyLevel: undefined };

const resetHierarchyLevel =
	() =>
	({ setState }: { setState: (arg1: State) => void }) =>
		setState({ ...initialState });

const setHierarchyLevel =
	(hierarchyLevel: number) =>
	({ setState, getState }: { setState: (arg1: State) => void; getState: () => State }) => {
		const state = getState();

		setState({ ...state, hierarchyLevel });
	};

const actions = {
	resetHierarchyLevel,
	setHierarchyLevel,
} as const;

type Actions = typeof actions;

const Store = createStore<State, Actions>({
	initialState,
	actions,
	name: 'JWMHierarchyLevelStore',
});

export const useHierarchyLevel = createHook(Store);
